import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Button, CircularProgress, Box, Grid, Typography,
} from '@material-ui/core';

import { useTranslation } from 'react-i18next';

// import { Img } from 'react-image';
import { uniqueId } from 'lodash';
// import moment from 'moment';
import 'moment/locale/th';
// import Lightbox from 'react-image-lightbox';

// icon
import { UrgentIcon } from '../../../assets/svg/Icon';

import 'react-image-lightbox/style.css';

import { globalStyle } from '../../../global/style';
import './infobasin.css';

const useStyles = makeStyles(globalStyle);

export default function InfographBasin() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [hasError, sethasError] = useState();

  const [Basin, setBasin] = useState([]);
  const initPath = `/${process.env.REACT_APP_PATH}`;

  const sourceData = `${initPath}config/situation/situationConfig.json`;

  useEffect(() => {
    function getData() {
      setLoading(true);
      fetch(sourceData)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setBasin(data);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [sourceData]);

  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}

      <div className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box display="flex" alignItems="center">
              <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
                <UrgentIcon style={{ color: 'white' }} />
              </Box>
              <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ')}</Typography></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Box mt={1}>
              <Grid container spacing={3}>
                {Basin
                  .filter((checkShow) => checkShow.isShow)
                  .map((datas, i) => {
                    let toshow = '';
                    toshow = (
                      <Box display="block" width="100%">
                        <Box py={0.5} className="title_">{datas.name}</Box>
                        <Box className="box_" display="flex" justifyContent="center">
                          <Button id={`basin_${i}`} onClick={() => { window.open(datas.url_src, '_blank'); }} disabled={datas.url_src === ''}>
                            <Box
                              p={2}
                              component="img"
                              src={datas.img_src}
                              alt={datas.name}
                              className="imgbox_"
                            />
                          </Button>
                        </Box>
                      </Box>
                    );
                    return (
                      <Grid item xs={12} sm={6} md={4} key={uniqueId()}>
                        {toshow}
                      </Grid>
                    );
                  })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
